export default __webpack_public_path__ + "static/media/blogger.61b888db.svg";